import { render, staticRenderFns } from "./FixedAssetDispotition.vue?vue&type=template&id=624601ca"
import script from "./FixedAssetDispotition.vue?vue&type=script&lang=js"
export * from "./FixedAssetDispotition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports